/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HelpTicketContext } from './HelpTicketContext';
import {
    HelpTicketContextFromJSON,
    HelpTicketContextFromJSONTyped,
    HelpTicketContextToJSON,
    HelpTicketContextToJSONTyped,
} from './HelpTicketContext';

/**
 * 
 * @export
 * @interface CreateHelpTicketResponse
 */
export interface CreateHelpTicketResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateHelpTicketResponse
     */
    logFilePath: string;
    /**
     * 
     * @type {HelpTicketContext}
     * @memberof CreateHelpTicketResponse
     */
    autoContext?: HelpTicketContext;
}

/**
 * Check if a given object implements the CreateHelpTicketResponse interface.
 */
export function instanceOfCreateHelpTicketResponse(value: object): value is CreateHelpTicketResponse {
    if (!('logFilePath' in value) || value['logFilePath'] === undefined) return false;
    return true;
}

export function CreateHelpTicketResponseFromJSON(json: any): CreateHelpTicketResponse {
    return CreateHelpTicketResponseFromJSONTyped(json, false);
}

export function CreateHelpTicketResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateHelpTicketResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'logFilePath': json['logFilePath'],
        'autoContext': json['autoContext'] == null ? undefined : HelpTicketContextFromJSON(json['autoContext']),
    };
}

export function CreateHelpTicketResponseToJSON(json: any): CreateHelpTicketResponse {
    return CreateHelpTicketResponseToJSONTyped(json, false);
}

export function CreateHelpTicketResponseToJSONTyped(value?: CreateHelpTicketResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logFilePath': value['logFilePath'],
        'autoContext': HelpTicketContextToJSON(value['autoContext']),
    };
}

